var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"appcontent"}},[_c('FixNavBar'),_c('Topbox'),_c('NavBar'),_c('MalSwiper'),_c('MalBody')],1),_c('Bottombox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }